import ApiService from "@/utils/request"

export const homeServe = {
  pcHomeHomeBignewsGet(id, params) {
    return ApiService.query(`rencai/pc_home/home/bignews/${id}`, params)
  },
  pcHomeHomeMenuGet(deptId, params) {
    return ApiService.query(`rencai/pc_home/home/menu/${deptId}`, params)
  },
  pcHomeMerchantServicePage(params) {
    return ApiService.post(`merchant/servicePage/`, params)
  },
  pcHomeHomeHeadlinePage(params) {
    const deptId = params.deptId
    delete params.deptId
    return ApiService.query(
      `rencai/pc_home/home/headlinepage/${deptId}/`,
      params
    )
  },
  pcHomeHomeTalentMenuGet(id) {
    return ApiService.query(`rencai/pc_home/home/talent/menu/${id}`)
  },
  // 人才证书
  infoCertQuery() {
    return ApiService.get(`person/info/cert`)
  },
  // 人才证书二维码版
  infoCertWith2Query() {
    return ApiService.get(`person/info/certWith2`)
  },
  // 人才基本信息
  infoTalentQuery() {
    return ApiService.get(`person/info/talent`)
  },
  // 入选证书
  infoPoolCertQuery() {
    return ApiService.get(`person/info/pool/cert`)
  },
  // 人才证书二维码版
  infoPoolCertWith2Query() {
    return ApiService.get(`person/info/pool/certWith2`)
  },
  // 获取消息
  myMessageQuery(params) {
    return ApiService.post(`msg/search/my`, params)
  },
  myMessageDetail(id) {
    return ApiService.get(`msg/detail/${id}`)
  },
  myMessageRead(params) {
    return ApiService.query(`msg/read_batch`, params)
  },
  myMessageReadAll() {
    return ApiService.get(`msg/read_all`)
  }
}

export const innerServe = {
  rencaiPcHomeHomeSecondTextlist() {
    return ApiService.query(`rencai/pc_home/home/second/textlist`)
  },
  rencaiPcHomeHomeSecondPhonelist() {
    return ApiService.query(`rencai/pc_home/home/second/phonelist`)
  },
  rencaiPcHomeHomeSecondPublishlist() {
    return ApiService.query(`rencai/pc_home/home/second/publishlist`)
  },
  rencaiPcHomeHomeSecondPublishlistDetails(id) {
    return ApiService.query(`rencai/pc_home/home/second/publishlist/${id}`)
  },
  rencaiPcHomeHomeSecondVideolist() {
    return ApiService.query(`rencai/pc_home/home/second/videolist`)
  },
  pcHomeHomeViewaddPost(uid) {
    return ApiService.post(`rencai/pc_home/home/viewadd/${uid}`)
  }
}
